var _mask, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivePage1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_198_250",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16.6469V16.6469H0V0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16.6469V16.6469H0V0Z",
    fill: "#95D2AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V-1.18907H-1.18907V0H0ZM16.6469 0H17.836V-1.18907H16.6469V0ZM16.6469 16.6469V20.2141H17.836V16.6469H16.6469ZM0 16.6469H-1.18907V20.2141H0V16.6469ZM0 0V1.18907H16.6469V0V-1.18907H0V0ZM16.6469 0H15.4579V16.6469H16.6469H17.836V0H16.6469ZM16.6469 16.6469V13.0797H0V16.6469V20.2141H16.6469V16.6469ZM0 16.6469H1.18907V0H0H-1.18907V16.6469H0Z",
    fill: "white",
    mask: "url(#path-1-inside-1_198_250)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivePage1);
export default __webpack_public_path__ + "static/media/active-page-1.65dfe6da37060c9761456750317f2dc6.svg";
export { ForwardRef as ReactComponent };